/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { displayModal } from '@insticator/insticator-ui'; // iui-state
import { resetForm } from '@insticator/insticator-ui';
import { populateEditUserForm, updateUserInformationWithValidation, updateTableWithNewUserInformation } from 'state/actions/accountState/account_data';
// component
import EditUser from 'pages/dashboard/account/users/edituser/edituser';



/* ========== ~~~~~~~~~~ ACCOUNT EDIT USER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData }) => ({
    fields: accountData.editUser.fields,
    savingData: accountData.editUser.savingData,
    editable: accountData.editUser.editable,
    hasStoredData: false
});

// map actions
const mapDispatchToProps = dispatch => ({
    populateEditUserForm: (data) => dispatch(populateEditUserForm(data)),
    updateUserInformationWithValidation: (fields, updatedData, userUUID, successAction, failAction) => dispatch(updateUserInformationWithValidation(fields, updatedData, userUUID, successAction, failAction)),
    updateTableWithNewUserInformation: (data, index) => dispatch(updateTableWithNewUserInformation(data, index)),
    resetForm: formName => dispatch(resetForm(formName)),
    displayModal: bool => dispatch(displayModal(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditUser);
